import Balances from "@gotts.ai/ui/devtools/views/Balances";
import ChainControls from "@gotts.ai/ui/devtools/views/ChainControls";
import ContractInteraction from "@gotts.ai/ui/devtools/views/ContractInteraction";
import EventViewer from "@gotts.ai/ui/devtools/views/EventViewer";
import KeyManagement from "@gotts.ai/ui/devtools/views/KeyManagement";
import LiquidityUI from "@gotts.ai/ui/devtools/views/LiquidityUI";
import PoolExplorer from "@gotts.ai/ui/devtools/views/PoolExplorer";
// Shared devtools views
import ProtocolOverview from "@gotts.ai/ui/devtools/views/ProtocolOverview";
import SwapUI from "@gotts.ai/ui/devtools/views/SwapUI";
import TransactionLog from "@gotts.ai/ui/devtools/views/TransactionLog";
import UniswapXOrders from "@gotts.ai/ui/devtools/views/UniswapXOrders";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

// Webenv-unique views
import { Scenarios } from "./views/Scenarios.js";
import { StateManagement } from "./views/StateManagement.js";
import WebMcpPanel from "./views/WebMcpPanel.js";

// Vault views (lazy-loaded)
const VaultExplorer = lazy(
  () => import("@gotts.ai/ui/devtools/views/vaults/VaultExplorer"),
);
const VaultDetail = lazy(
  () => import("@gotts.ai/ui/devtools/views/vaults/VaultDetail"),
);
const CreateVault = lazy(
  () => import("@gotts.ai/ui/devtools/views/vaults/CreateVault"),
);
const FeeInspector = lazy(
  () => import("@gotts.ai/ui/devtools/views/vaults/FeeInspector"),
);

// Identity views (lazy-loaded)
const IdentityRegistry = lazy(
  () => import("@gotts.ai/ui/devtools/views/identity/IdentityRegistry"),
);
const RegisterIdentity = lazy(
  () => import("@gotts.ai/ui/devtools/views/identity/RegisterIdentity"),
);
const IdentityDetail = lazy(
  () => import("@gotts.ai/ui/devtools/views/identity/IdentityDetail"),
);

function LazyFallback() {
  return (
    <div className="text-text-muted flex items-center gap-2 font-mono text-xs">
      Loading...
    </div>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ProtocolOverview />} />
      <Route path="/pools" element={<PoolExplorer />} />
      <Route path="/swap" element={<SwapUI />} />
      <Route path="/liquidity" element={<LiquidityUI />} />
      <Route path="/uniswapx" element={<UniswapXOrders />} />
      <Route
        path="/vaults"
        element={
          <Suspense fallback={<LazyFallback />}>
            <VaultExplorer />
          </Suspense>
        }
      />
      <Route
        path="/vaults/create"
        element={
          <Suspense fallback={<LazyFallback />}>
            <CreateVault />
          </Suspense>
        }
      />
      <Route
        path="/vaults/:address"
        element={
          <Suspense fallback={<LazyFallback />}>
            <VaultDetail />
          </Suspense>
        }
      />
      <Route
        path="/fees"
        element={
          <Suspense fallback={<LazyFallback />}>
            <FeeInspector />
          </Suspense>
        }
      />
      <Route
        path="/agents"
        element={
          <Suspense fallback={<LazyFallback />}>
            <IdentityRegistry />
          </Suspense>
        }
      />
      <Route
        path="/agents/register"
        element={
          <Suspense fallback={<LazyFallback />}>
            <RegisterIdentity />
          </Suspense>
        }
      />
      <Route
        path="/agents/:id"
        element={
          <Suspense fallback={<LazyFallback />}>
            <IdentityDetail />
          </Suspense>
        }
      />
      <Route path="/chain" element={<ChainControls />} />
      <Route path="/keys" element={<KeyManagement />} />
      <Route path="/contracts" element={<ContractInteraction />} />
      <Route path="/balances" element={<Balances />} />
      <Route path="/txlog" element={<TransactionLog />} />
      <Route path="/events" element={<EventViewer />} />
      <Route path="/scenarios" element={<Scenarios />} />
      <Route path="/state" element={<StateManagement />} />
      <Route path="/webmcp" element={<WebMcpPanel />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
